import { Close, Download } from '@mui/icons-material';
import { Modal, Box, IconButton, Button } from '@mui/material';

interface PDFViewerDialogProps {
  fileUrl: string;
  open: boolean;
  onClose: () => void;
  fileType: "pdf" | "image";
}

const FilePreviewDialog = ({ fileUrl, open, onClose, fileType }: PDFViewerDialogProps) => {
  const handleDownload = () => {
    const a = document.createElement("a");
    a.href = fileUrl;
    a.download = fileUrl?.split("/")?.pop() || "invoice";;
    a.target = "_blank";
    a.click();
  };

  const handlePrint = () => {
    const iframe = document.createElement("iframe");
    iframe.style.display = "none";
    iframe.src = fileUrl;
    document.body.appendChild(iframe);
    iframe.contentWindow?.print();
    document.body.removeChild(iframe);
  };
  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          bgcolor: "white",
          boxShadow: 24,
          p: 2,
          paddingTop: 5,
          width: "80%",
          height: "80%",
          display: "flex",
          flexDirection: "column",
        }}
      >
        <IconButton
          sx={{
            position: "absolute",
            top: '0.25%',
            right: '5%',
          }}
          onClick={handleDownload}
        >
          <Download />
        </IconButton>
        <IconButton
          sx={{
            position: "absolute",
            top: 0,
            right: '1%',
          }}
          onClick={onClose}
        >
          <Close />
        </IconButton>
        {/* PDF Display */}
        {fileType === "pdf" ? (
            <iframe
              src={fileUrl}
              style={{
                width: "100%",
                height: "100%",
                border: "none",
              }}
            />
          ) : (
            <img
              src={fileUrl}
              alt="Preview"
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
              }}
            />
          )}
      </Box>
    </Modal>
  );
};

export default FilePreviewDialog;
